import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class LoadingphaseService {
    private emitters = new Map<string, EventEmitter<boolean>>();
    private contentBlockEmitter = new EventEmitter<boolean>();
    private currentBlockstate: boolean;
    private contentBlockEnabled = true;

    public get ContentBlockEnabled(): boolean {
        return this.contentBlockEnabled;
    }

    public get CurrentContentBlockState(): boolean {
        return this.currentBlockstate;
    }

    public enableContentBlock(value: boolean) {
        this.contentBlockEnabled = value;
        if (value) {
            this.setContentBlockState(this.currentBlockstate);
            return;
        }
        this.setContentBlockState(false);
    }

    public subscribeToContentBlockEmitter(subscribe: (state: boolean) => void) {
        this.contentBlockEmitter.subscribe(subscribe);
    }

    public setContentBlockState(state: boolean) {
        if (this.contentBlockEnabled) {
            this.contentBlockEmitter.emit(state);
        } else {
            this.contentBlockEmitter.emit(false);
        }
        this.currentBlockstate = state;
    }

    public setLoadingphase(phase: boolean, ...scopes: string[]) {
        scopes.forEach((scope) => {
            const emitter = this.emitters.get(scope);
            if (emitter) {
                emitter.emit(phase);
            }
        });
    }

    public getLoadingEventEmitter(scope: string) {
        let emitter = this.emitters.get(scope);
        if (!emitter) {
            emitter = new EventEmitter<boolean>();
            this.emitters.set(scope, emitter);
        }
        return emitter;
    }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/service/loadingphase.service.ts